export default "__VITE_ASSET__BNB$3njl__"